import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";
import {
  UserName,
  UserNameContent,
  UserNameDetail,
  UserNameLabel,
} from "@/blocks/UserName";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

function ParticipantsExample() {
  return (
    <Section data-test="participants-section">
      <SectionHeader>
        <SectionTitle>Participants</SectionTitle>
      </SectionHeader>
      <div className="flex flex-col gap-2">
        <UserName data-test="user">
          <UserNameContent>
            <UserNameLabel data-test="user-name">Alice Martin</UserNameLabel>
            <UserNameDetail>Agent</UserNameDetail>
          </UserNameContent>
        </UserName>
        <UserName data-test="user">
          <UserNameContent>
            <UserNameLabel data-test="user-name">Bob Durand</UserNameLabel>
            <UserNameDetail>+33 1 23 45 67 89</UserNameDetail>
          </UserNameContent>
        </UserName>
        <UserName data-test="user">
          <UserNameContent>
            <UserNameLabel data-test="user-name">
              +33 6 98 76 54 32
            </UserNameLabel>
          </UserNameContent>
        </UserName>
      </div>
    </Section>
  );
}

export function PlaygroundSectionParticipants() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Participants Section
        </PlaygroundSubSectionTitle>
        <ParticipantsExample />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
